import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { Subscription } from 'rxjs';
import { DynamicFormService } from 'src/app/shared/forms/dynamic-form/dynamic-form.service';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { ToggelComponent } from '../../../design-system/toggel/toggel.component';

@Component({
    selector: 'formly-toggle',
    templateUrl: "./formly-toggle.component.html",
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, FormlyModule, ToggelComponent]
})
export class FormlyToggleComponent extends FieldType implements OnInit, OnDestroy {
    constructor(private dynamicFormService: DynamicFormService) {
        super();
    }

    param: any;
    isFormSubmitted: boolean = false;
    formSubmissionSubscription: Subscription;
    valueChangesSubscription: Subscription;
    fieldKey: string;
    enableBigToggle = true;
    toggleConfig = {
        label: '',
        labelPosition: 'left',
        size: 'md',
        isActive: true,
        disabled: false,
        id: ''
    }

    ngOnInit() {
        if (this.field.key) {
            this.fieldKey = this.field.id ?? this.field.key.toString();
        }
        this.formSubmissionSubscription = this.dynamicFormService.getFormSubmittedEvent().subscribe(data => {
            this.isFormSubmitted = data;
        });
        if (this.to.options && this.to.options[0] && this.to.options[0].enableBigToggle != undefined) {
            this.enableBigToggle = this.to.options[0].enableBigToggle;
        }
        if (this.field.templateOptions) {
            this.toggleConfig.label = this.field.templateOptions.label;
            this.toggleConfig.labelPosition = this.field.templateOptions.labelPosition;
            this.toggleConfig.disabled = this.field.templateOptions.disabled;
            this.toggleConfig.size = this.field.templateOptions.size;
            this.toggleConfig.isActive = this.formControl.value;
            this.toggleConfig.id = this.fieldKey;
        }
        if (this.to) {
            this.toggleConfig.label = this.toggleConfig.isActive ? (this.to.labelActive || this.toggleConfig.label) : (this.to.labelDeactive || this.toggleConfig.label);
        }
        if (this.formControl && this.formControl.valueChanges) {
            this.valueChangesSubscription = this.formControl.valueChanges.subscribe(val => {
                const isActive = !!val;
                this.toggleConfig = {
                    ...this.toggleConfig,
                    isActive,
                    label: isActive ? (this.to.labelActive || this.toggleConfig.label) : (this.to.labelDeactive || this.toggleConfig.label)
                };
            });
        }
    }

    ngOnDestroy() {
        if (this.formSubmissionSubscription) {
            this.formSubmissionSubscription.unsubscribe();
        }
        if (this.valueChangesSubscription) {
            this.valueChangesSubscription.unsubscribe();
        }
    }

    onValueChange(event) {
        this.formControl.setValue(event);
        this.to.change(this.field, this.formControl.value);
    }
}